var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jaya-connection-layout',{attrs:{"text":"Une mise à jour est nécessaire !"}},[_c('b-button',{staticClass:"col-12 mb-2",on:{"click":_vm.getAppLink}},[_vm._v(" Mettre à jour l'application ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }